define('account-crop-avatar',['controller', 'lib/jquery.jcrop'], function(controller) {
	controller.on('account/crop_avatar', function() {
		$('#preview-image-container').hide();
		
		var jcrop_api;
		var dim;
		
		$('#cropbox').Jcrop({
			aspectRatio: 1,
			onSelect: update,
			onChange: update,
			boxWidth: 490,
			boxHeight: 490,
			bgColor: 'white',
			bgOpacity: .3,
			onRelease: function() {$('#preview-image-container').hide();}
		},function(){
			jcrop_api = this;
			jcrop_api.setOptions({ allowMove: true });
			dim = jcrop_api.getBounds();
			selectMax();
		});
		
		$('#select-max').click(function(e) {
			selectMax();
		});
		
		function selectMax() {
			var x = 0, y = 0, x_ = dim[0], y_ = dim[1];

			var x_r = x_ - y_;
			var y_r = y_ - x_;

			if (x_r > 0) {
			    x = x_r / 2;
			}
			
			if (y_r > 0) {
			    y = y_r / 2;
			}
			
			jcrop_api.animateTo([x,y,x_,y_]);
		}
		
		function update(c) {			
			// update coords
			$('#x').val(c.x);
			$('#y').val(c.y);
			$('#w').val(c.w);
			$('#h').val(c.h);
			
			// disable submit button if nothing is selected
			var submitButton = $('#submit-cropped-avatar');
			if (c.w == 0) {
				submitButton.prop('disabled', true);
			} else {
				submitButton.prop('disabled', false);
			}
			
			// show preview
			$('#preview-image-container').show();
			
			var rx = 80 / c.w;
			var ry = 80 / c.h;

			$('#preview').css({
				width: Math.round(rx * $('#cropbox').width()) + 'px',
				height: Math.round(ry * $('#cropbox').height()) + 'px',
				marginLeft: '-' + Math.round(rx * c.x) + 'px',
				marginTop: '-' + Math.round(ry * c.y) + 'px'
			});
		}
	});
});
